export const translatedAnswers: Record<string, Record<string, string>> = {
    org_contacted_c: {
        'Ja': '1',
        'Nej': '0',
    },
    org_replied_c: {
         'Ja': '1',
        'Nej': '0',
    },
    informant_c:{
        'Privatperson':'private',
        'Organisation':'organisation'
    },
}


export const specialMappedQuestions = new Set([
    
])
